export class Registration {

    public campaignData = null;
    public campaignId = null;
    public desc = null;
    public id = null;
    public label = null;
    public link = null;
    public registrationType = null;
    public virtualEventId = null;

    constructor(registration) {
        this.campaignData = registration.campaignData || { };
        this.campaignId = registration.campaignId;
        this.desc = registration.desc;
        this.id = registration.id;
        this.label = registration.label;
        this.link = registration.link;
        this.registrationType = registration.registrationType;
        this.virtualEventId = registration.virtualEventId;
    }

    disabledButton() {
        return this.registrationType === 0 && (this.isArchivedOrDeactivated() || this.isCampaignExpaired());
    }

    isArchivedOrDeactivated() {
        return this.campaignData.status === 5 || this.campaignData.status === 2;
    }

    isCampaignExpaired() {
        return +new Date() > +new Date(this.campaignData.endDate);
    }
}
